import { createContext, useContext } from "react";
//#region src/components/ThemeRoot/BrandContext.ts
var BrandContext = createContext(null);
/**
* The nearest ThemeRoot's brand: the pack and the tenant's resolved names, logo,
* accent, density, secure host and help links. Throws outside a ThemeRoot.
*/
function useBrand() {
	const brand = useContext(BrandContext);
	if (!brand) throw new Error("useBrand() needs a <ThemeRoot> above it");
	return brand;
}
/** The nearest ThemeRoot's brand, or null outside one (for components with fallbacks). */
function useOptionalBrand() {
	return useContext(BrandContext);
}
//#endregion
export { BrandContext, useBrand, useOptionalBrand };

//# sourceMappingURL=BrandContext.js.map